import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZAssetImage = z.object({
  imageName: z.string(),
  imageUrl: z.string()
})

const ZApiResponse = z.object({
  http_status: z.number(),
  data: z.optional(ZAssetImage.array()),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type AssetImage = z.infer<typeof ZAssetImage>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function getAssetImages (
  assetId: string,
  numberOfImages: number,
  width: number,
  height: number,
  onSuccess: (images: AssetImage[], httpStatus: number) => any,
  onFailure: (httpStatus: number) => any
): Promise<void> {
  const url = `/fileuploadservice/api/v1/udp/asset-profile/download-meter-images?assetId=${assetId}&numberOfImages=${numberOfImages}&width=${width}&height=${height}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (parseResponse.data.data !== undefined && Array.isArray(parseResponse.data.data) && parseResponse.data.data.length > 0) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure(response.status)
        }
      } else {
        onFailure(response.status)
      }
    })
    .catch((error) => {
      if (error.response?.status !== undefined) {
        onFailure(error.response.status)
      } else {
        onFailure(500)
      }
    })
}
